import { render, staticRenderFns } from "./mInfoBox.vue?vue&type=template&id=e66131ae&scoped=true"
import script from "./mInfoBox.vue?vue&type=script&lang=ts"
export * from "./mInfoBox.vue?vue&type=script&lang=ts"
import style0 from "./mInfoBox.vue?vue&type=style&index=0&id=e66131ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66131ae",
  null
  
)

export default component.exports